
export const appBarConstants = {
  OPEN_MI_CUENTA: 'APPBAR_OPEN_MI_CUENTA',
  CLOSE_MI_CUENTA:  'APPBAR_CLOSE_MI_CUENTA',
  OPEN_LOGIN_DIALOG: 'APPBAR_OPEN_LOGIN_DIALOG',
  CLOSE_LOGIN_DIALOG: 'APPBAR_CLOSE_LOGIN_DIALOG',
};